import { render, staticRenderFns } from "./AddFolder.vue?vue&type=template&id=0f4f5920&scoped=true"
import script from "./AddFolder.vue?vue&type=script&lang=js"
export * from "./AddFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f5920",
  null
  
)

export default component.exports